import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardGuru } from 'app/KinerjaPage/components/PageGuardGuru'
import { AjukanPerencanaan } from 'app/KinerjaGuruPage/pages/perencanaan/AjukanPerencanaan'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPerencanaanEnabled =
      toggle?.['kinerja-perencanaan-enabled'] || false
    const isKinerjaPerencanaan2026Enabled =
      toggle?.['kinerja-perencanaan-2026-enabled'] || false

    if (
      !isKinerjaEnabled ||
      !isKinerjaPerencanaanEnabled ||
      !isKinerjaPerencanaan2026Enabled
    ) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardGuru>
      <AjukanPerencanaan />
    </PageGuardGuru>
  )
}

Page.Layout = KinerjaLayout
